import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTreeAuth } from '../../lib/treeAuth';
import { LogOut, ScanFace } from 'lucide-react';
import { Button } from '../ui/button';
import { TreePasskeyManager } from './TreePasskeyManager';

const WC_LOGO = "https://customer-assets.emergentagent.com/job_tree-logistics/artifacts/7lohxwsd_2025Logo.png";

const ROLE_LABELS = {
  field_status: 'Field Status',
  field_collector: 'Field Collector',
  admin: 'Admin',
};

export default function TreeTaskLayout({ title, subtitle, children }) {
  const { user, logout } = useTreeAuth();
  const navigate = useNavigate();
  const [showPasskeys, setShowPasskeys] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/trees/login');
  };

  return (
    <div className="min-h-screen bg-[#F4F1ED]" data-testid="tree-task-layout">
      <header className="sticky top-0 z-20 bg-white/95 backdrop-blur-xl border-b border-[#1A4331]/15 px-4 py-3 flex items-center justify-between">
        <img src={WC_LOGO} alt="Wilson Contractors" className="h-7 object-contain" />
        <div className="flex items-center gap-1">
          <Button variant="ghost" size="sm" onClick={() => setShowPasskeys(true)} className="text-[#4A5D53]" data-testid="tree-task-manage-passkey-button">
            <ScanFace className="w-4 h-4" />
          </Button>
          <Button variant="ghost" size="sm" onClick={handleLogout} className="text-[#4A5D53]" data-testid="tree-task-logout-button">
            <LogOut className="w-4 h-4 mr-1.5" /> Sign Out
          </Button>
        </div>
      </header>

      <TreePasskeyManager open={showPasskeys} onOpenChange={setShowPasskeys} />

      <div className="px-4 pt-5 pb-2 max-w-md mx-auto">
        <p className="text-[11px] uppercase tracking-[0.2em] font-bold text-[#E27B58]">{ROLE_LABELS[user?.role] || 'Field'}</p>
        <h1 className="text-2xl font-bold text-[#0A1711] font-['Outfit'] tracking-tight mt-0.5">{title}</h1>
        {subtitle && <p className="text-sm text-[#4A5D53] mt-1">{subtitle}</p>}
        <p className="text-xs text-[#4A5D53]/70 mt-0.5">{user?.name}</p>
      </div>

      <main className="px-4 pb-10 max-w-md mx-auto">
        {children}
      </main>
    </div>
  );
}
